// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1___26d757314ce518c1440","cls2":"Header-cls2___6a5b94c5122b55917f9 Header-cls1___26d757314ce518c1440"};